//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import list from './dataList.json';
export default {
  name: 'resbdguideunitsize',
  props: {
    msg: String
  },
  data(){
     return{
        buildHeadBeans:{
        UnitBean:[]
    },
    floorBeanLists:[]
     }
  },
  mounted(){
   
  },
  computed:{
  
  },
  watch:{
      floorBeanList:{
       handler:function(newval,oldval){
            this.floorBeanLists=this.floorBeanList
       },
       deep: true
     },
     buildHeadBean:{
       handler:function(newval,oldval){
            this.buildHeadBeans=this.buildHeadBean
       },
       deep: true
     },
  },
  props: {
    buildHeadBean:Object,
    floorBeanList:Array,
    model: Object,
    getLangMsg: Function,
    invoke: Function
  },
   created() {
    this.handleToNextStep()
  },
  methods:{
     handleToNextStep: function () {
      console.log('init_data')
      this.invoke('invokeCustomEvent',{content:{ type: 'guideunitsize_init_data', value:''}})
    },
      changeHoldname(e,n){
      console.log(e.target.value,n,'e')
      //  if(e.target.value){
           let value={
            unitId:this.buildHeadBeans.unitBeanList[n].id,
            unitName:e.target.value
         }
         let parm={content:{ type:'guideunitsize_set_unitname', value:value}}
         console.log('传给后台的参数',parm)
         this.invoke('invokeCustomEvent',parm) 
      //  }
    },
    changeHoldsize(e,n){
        console.log(e.target.value,n,'e')
      //  if(e.target.value){
           let value={
            unitId:this.buildHeadBeans.unitBeanList[n].id,
            unitSize:e.target.value
         }
         let parm={content:{ type:'guideunitsize_set_unitsize', value:value}}
         console.log('传给后台的参数',parm)
         this.invoke('invokeCustomEvent',parm) 
    }
  }
}
